import { useMemo } from "react";
import { SWRConfig } from "swr";
import { locations } from "@contentful/app-sdk";
import { useSDK } from "@contentful/react-apps-toolkit";
import { handleSwrRetry, localeStorageStore } from "./lib";
import { ConfigScreen, NewFeaturesDialog, SidebarWrapper } from "./locations";

export const App = () => {
    const sdk = useSDK();

    const Component = useMemo(() => {
        if (sdk.location.is(locations.LOCATION_ENTRY_SIDEBAR)) {
            return SidebarWrapper;
        }

        if (sdk.location.is(locations.LOCATION_APP_CONFIG)) {
            return ConfigScreen;
        }

        if (sdk.location.is(locations.LOCATION_DIALOG)) {
            return NewFeaturesDialog;
        }
    }, [sdk.location]);

    return Component ? (
        <SWRConfig
            value={{
                provider: localeStorageStore,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                /* 24 days (tested to be max amount of days that works) */
                refreshInterval: 1000 * 60 * 60 * 24 * 24,
                onErrorRetry: handleSwrRetry(sdk),
            }}>
            <Component />
        </SWRConfig>
    ) : null;
};
